export default {
  loading: "拼命加载中",
  totalData: "条数据",
  totalPrefix: "共计",
  startDate: "开始日期",
  endDate: "结束日期",
  reset: "重置",
  search: "查询",
  loadMore: "加载更多数据",
  loadCompleted: "已全部加载完成",
  collapse: "收起",
  noData: "暂无数据",
  directions: {
    withdraw: "提现",
    deposit: "充值",
    buy: "买入",
    sell: "卖出",
    unknown: "未知",
  },
  common: {
    noBank: "暂无查询到相关银行",
  },
};
